export default __webpack_public_path__ + "static/media/kuya.7c4b2b24.jpg";